module.exports = __webpack_public_path__ + "static/icon-sick.0f3b7555.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-sick.png
// module id = 292
// module chunks = 2